/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-components';
import type { JSXElement } from '@fluentui/react-utilities';
import type { GhostTextState, GhostTextSlots } from './GhostText.types';

/**
 * Render the final JSX of GhostText
 */
export const renderGhostText_unstable = (state: GhostTextState): JSXElement => {
  assertSlots<GhostTextSlots>(state);

  return (
    <state.root>
      {state.root.children}
      {state.indicator && <state.indicator />}
    </state.root>
  );
};
